import { ResourceUserBadges } from "@/components/resource-user-badges";
import { Badge } from "@/components/ui/badge";
import type { Invoice } from "@/types";
import { formatDateAR } from "@/utils/date";

interface InvoiceHeaderProps {
  invoice: Invoice;
  status: {
    label: string;
    variant: "outline" | "default" | "secondary" | "destructive";
  };
}

export default function InvoiceHeader({ invoice, status }: InvoiceHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="space-y-1">
        <h1 className="text-3xl font-semibold tracking-tight">
          {invoice.invoice_number ?? `Factura #${invoice.id}`}
        </h1>
        <p className="text-sm text-muted-foreground">
          Fecha:{" "}
          {invoice.invoice_date ? formatDateAR(invoice.invoice_date) : "-"}
        </p>
        <ResourceUserBadges
          createdBy={invoice.created_by}
          reviewedBy={invoice.reviewed_by}
        />
      </div>
      {status?.label && status?.variant && (
        <Badge variant={status?.variant}>{status.label}</Badge>
      )}
    </div>
  );
}
